import styled from 'styled-components'
import { Card } from 'react-bootstrap'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import BooksitoutImages from '../../../images/BooksitoutImages'
import BooksitoutIcon from '../../../config/BooksitoutIcon'
import ColorConfig from '../../../config/ColorConfig'

interface BookIsbnCardProps {
	book: { isbn13: string; title: string; authors: string; coverUrl: string | null }
	onClick?: () => void
	href?: string
	isAdded?: boolean
}

const BookIsbnCard = ({ book, onClick, href, isAdded }: BookIsbnCardProps) => (
	<BookItem
		href={isAdded ? (href ?? undefined) : (href ?? `/book/${book.isbn13}?q=${book.title}`)}
		onClick={isAdded && !href ? (e) => e.preventDefault() : onClick ? (e) => { e.preventDefault(); onClick() } : undefined}
		style={isAdded && !href ? { cursor: 'default' } : undefined}
	>
		<Card className="h-100 hover-effect">
			<CardBodyContentContainer backgroundColorType={'card-card'} style={isAdded ? { opacity: '60%' } : undefined}>
				{isAdded && (
					<CheckMarkContainer>
						<CheckMark />
					</CheckMarkContainer>
				)}
				<BookCoverWrapper>
					<BookCover
						src={book.coverUrl || BooksitoutImages.Placeholder.bookCover}
						alt={book.title}
						onError={(e: any) => e.target.src = BooksitoutImages.Placeholder.bookCover}
					/>
				</BookCoverWrapper>
				<BookInfo>
					<BookTitleWrapper>
						<BookTitle><span>{book.title}</span></BookTitle>
					</BookTitleWrapper>
					<BookAuthor>{book.authors}</BookAuthor>
				</BookInfo>
			</CardBodyContentContainer>
		</Card>
	</BookItem>
)

export const BookIsbnCardGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
	row-gap: 24px;
	column-gap: 16px;
`

const CheckMarkContainer = styled.div`
	position: absolute;
	right: 10px;
	top: 5px;
`

const CheckMark = styled(BooksitoutIcon.check)`
	font-size: 25px;
	color: ${ColorConfig.Primary};
`

const BookItem = styled.a`
	text-decoration: none;
	color: inherit;
`

const BookCoverWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 180px;
	overflow: hidden;
`

const BookCover = styled.img`
	max-height: 180px;
	max-width: 100%;
	object-fit: contain;
	border-radius: 6px;
`

const BookInfo = styled.div`
	padding-top: 10px;
`

const BookTitleWrapper = styled.div`
	height: 40px;
	display: table;
	width: 100%;
`

const BookTitle = styled.div`
	display: table-cell;
	vertical-align: middle;
	font-size: 14px;
	font-weight: 500;
	text-align: center;
	line-height: 1.4;

	& > span {
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
`

const BookAuthor = styled.div.attrs({ className: 'clamp-1-line' })`
	margin-top: 8px;
	font-size: 12px;
	color: var(--sub-text-color);
	text-align: center;
`

export default BookIsbnCard
